import { useContent, useExcursionContext } from "@op/utils";
import type { ExcursionLinkMarkProps } from "../../../../../renderer/RichTextRenderer/marks/ExcursionLinkMark";
import { useMemo } from "react";
import { Dc_Text_Link_Excursion_Unsynced } from "@op/sf-op";

const ExcursionLinkMark = ({ slug, children }: ExcursionLinkMarkProps) => {
  const { excursions } = useContent();
  const { addOpenExcursion } = useExcursionContext();

  const excursion = useMemo(() => {
    return excursions.find((g) => g.slug === slug);
  }, [excursions, slug]);

  if (!excursion) return null;
  return (
    <a className="contents" onClick={() => addOpenExcursion(excursion.slug)}>
      <Dc_Text_Link_Excursion_Unsynced text={children} />
    </a>
  );
};

export default ExcursionLinkMark;
